class measurementSettingDetailSave {
  // debugger;
  MeasurementSettingsID_GUID: string;
  MeasurementSettingsDetailID_GUID: string;
  IsNote: Boolean;
  FieldType: number;
  innerObj: any;

  measurementSettingDetailSave() {
    // debugger;
    this.MeasurementSettingsID_GUID = "";
    this.MeasurementSettingsDetailID_GUID = "";
    this.IsNote = false;
    this.FieldType = 1;
  }
}

export default measurementSettingDetailSave;
